define.alias("shared/components/shared/ui/report/settings", "settings/components/shared/ui/report/settings");